import React, { useState, useMemo, useEffect, use } from "react";
import {
  BackArrow,
  ConnectVideoCall,
  InvertedInfoIcon,
  PhoneIcon,
  ThreeDotMenu,
} from "assets/icons";
import Avatar from "components/BaseWidgets/Avatar";
import "./style.scss";
import Dropdown from "components/BaseWidgets/dropdown";
import Button from "components/BaseWidgets/button";
import { useNavigate } from "react-router-dom";
import { retrieveToken } from "utils/storage";
import profilePic from "assets/images/png/dummy_avatar.png";
import {
  doc,
  updateDoc,
  collection,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { db, rtdb } from "../../../../../firebase/firebaseChat";
import { useBlockChat } from "hooks/api/useBlockChat";
import { useChatPreference } from "hooks/api/useChatPreference";
import { useReportProfile } from "hooks/api/useOnboard";
import ReportProfileModal from "components/Cards/ProfileCard/components/ReportProfileModal";
import { ref, onValue } from "firebase/database";

const ChatHeader = ({
  selectedChatId,
  userChats,
  selectedThread,
  reqAccepted,
  chatDetail,
  onBack,
}) => {
  const user = JSON.parse(retrieveToken("user") || "{}");
  const currentUserId = user?.aec_id;

  const navigate = useNavigate();
  const { mutateAsync: blockChatApi } = useBlockChat();
  const { mutateAsync: updatePreferenceApi } = useChatPreference();
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(false);
  const [changed, setChanged] = useState(false);

  const { mutate: reportProfileMutate } = useReportProfile({
    onSuccess: () => {
      setIsReportModalOpen(false);
    },
  });
  const clearMessages = async (chatId) => {
    const messagesRef = collection(db, "chats", chatId, "messages");
    const snapshot = await getDocs(messagesRef);

    const batch = [];
    snapshot.forEach((docSnap) => {
      batch.push(deleteDoc(docSnap.ref));
    });

    await Promise.all(batch);
  };

  const updateSetting = async (chatId, userId, data) => {
    const chatRef = doc(db, "chats", selectedChat.id);
    await updateDoc(chatRef, {
      [`userSettings.${userId}`]: data,
    });
  };

  // ✅ Find selected chat
  const selectedChat = userChats.find(
    (chat) => chat.id === selectedChatId || chat.chatId === selectedChatId
  );

  // console.log(selectedChat, "selectedChat");

  // ✅ Find opposite user (the one who isn’t currentUserId)
  const oppositeUserId = selectedChat?.users?.find(
    (id) => id !== currentUserId
  );

  useEffect(() => {
    let selectedChat = userChats.find(
      (chat) => chat.id === selectedChatId || chat.chatId === selectedChatId
    );
    // console.log(selectedChat, "test");
  }, [userChats]);

  const oppositeUser = selectedChat?.participants?.[oppositeUserId] || {};
  const isTyping = selectedChat?.typingStatus[oppositeUserId] || false;
  // console.log(isTyping, "isTyping");

  const { isAccepted } = oppositeUser;

  const lastSeenTs = selectedChat?.lastSeen?.[oppositeUserId];
  const lastSeenFormatted = new Date(changed).toLocaleString([], {
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    day: "numeric",
  });
  // const lastSeenFormatted = lastSeenTs?.seconds
  //   ? new Date(lastSeenTs.seconds * 1000).toLocaleString([], {
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       month: "short",
  //       day: "numeric",
  //     })
  //   : null;

  const handleOnClick = () => {
    navigate("/connect");
  };
  // console.log(currentUserId, "currentUserId", selectedChat?.userSettings);

  useEffect(() => {
    if (!selectedThread?.aec_id) return;

    const statusRef = ref(rtdb, `/status/${selectedThread?.aec_id}`);

    const unsubscribe = onValue(statusRef, (snapshot) => {
      const data = snapshot.val();
      // console.log("📡 RTDB presence:", selectedThread?.aec_id, data);
      setIsOnline(data?.online ? true : false);
      // console.log(data?.lastChanged, "");

      setChanged(data?.lastChanged || null);
    });

    return () => unsubscribe();
  }, [selectedThread?.aec_id]);

  // console.log(isOnline, "jsh");

  const handleDropdownClick = async ({ key }) => {
    if (!selectedChatId || !currentUserId) return;

    const currentSettings = {
      muted: false,
      pinned: false,
      favorite: false,
      clear: false,

      blocked: false,
      ...selectedChat?.userSettings?.[currentUserId],
    };

    try {
      switch (key) {
        case "mute":
          await updatePreferenceApi({
            thread_id: selectedThread.thread_id,
            muted: !currentSettings.muted,
          });
          await updateSetting(selectedChatId, currentUserId, {
            ...currentSettings,
            muted: !currentSettings.muted,
          });
          break;

        case "pin":
          await updatePreferenceApi({
            thread_id: selectedThread.thread_id,
            pinned: !currentSettings.pinned,
          });
          await updateSetting(selectedChatId, currentUserId, {
            ...currentSettings,
            pinned: !currentSettings.pinned,
          });
          break;

        case "favorite":
          await updatePreferenceApi({
            thread_id: selectedThread.thread_id,
            favorite: !currentSettings.favorite,
          });
          await updateSetting(selectedChatId, currentUserId, {
            ...currentSettings,
            favorite: !currentSettings.favorite,
          });
          break;

        case "block":
          await blockChatApi(selectedThread.thread_id);
          await updateSetting(selectedChatId, currentUserId, {
            ...currentSettings,
            blocked: !currentSettings.blocked,
          });
          break;

        case "clear":
          await updatePreferenceApi({
            thread_id: selectedThread.thread_id,
            clear_chat: !currentSettings.clear,
          });
          await clearMessages(selectedChatId);
          break;

        case "report":
          setIsReportModalOpen(true);
          // console.log("TODO: report user (modal)");
          break;

        default:
          break;
      }
    } catch (err) {
      console.error("🔥 Chat action failed:", err);
    }
  };

  const chatHeaderMenuItems = [
    { key: "mute", label: chatDetail?.is_muted ? "Unmute chat" : "Mute chat" },
    {
      key: "pin",
      label: chatDetail?.is_pinned ? "Unpin chat" : "Pin the chat",
    },
    { key: "clear", label: "Clear chat" },
    {
      key: "favorite",
      label: chatDetail?.is_favorited ? "Remove favorite" : "Favorite chat",
    },
    {
      key: "block",
      label: chatDetail?.is_blocked ? "Unblock user" : "Block user",
    },
    { key: "report", label: "Report the profile" },
  ];

  if (!selectedChatId) {
    return <div className="chat-header">No chat selected</div>;
  }

  return (
    <div className="chat-header">
      <div className="left-group">
        {isAccepted && (
          <Button onClick={handleOnClick} variant="custom" height={24}>
            <BackArrow stroke="#323232" />
          </Button>
        )}
        <Button
          size="none"
          className="mobile-back-btn"
          onClick={onBack}
        >
          <BackArrow stroke="#323232"/>
        </Button>
        <div className="chat-user">
          <div className="avatar-wrapper">
            <Avatar
              url={
                selectedThread?.profile_image &&
                typeof selectedThread?.profile_image === "string"
                  ? selectedThread?.profile_image
                  : profilePic
              }
              size={32}
            />
            {isOnline && <span className="online-dot" />}
          </div>
          <div className="user-details">
            <span className="name">
              {selectedThread?.username || "Unknown User"}
            </span>
            <span className="status">
              {isTyping
                ? "Typing..."
                : isOnline
                  ? "Online"
                  : lastSeenFormatted
                    ? `Last seen ${lastSeenFormatted}`
                    : "Offline"}
            </span>
          </div>
        </div>
      </div>

      <div className="actions">
        {/* {isAccepted ? (
          <>
            <ConnectVideoCall className="icon" />
            <PhoneIcon className="icon" />
            <Dropdown
              items={chatHeaderMenuItems}
              label={null}
              icon={<ThreeDotMenu className="icon" />}
              trigger={["click"]}
              onClick={handleDropdownClick}
            />
          </>
        ) : ( */}
        {chatDetail?.request_exist === false && (
          <Dropdown
            items={chatHeaderMenuItems}
            icon={<ThreeDotMenu className="icon" />}
            trigger={["click"]}
            label={null}
            onClick={handleDropdownClick}
          />
        )}
        {/* )} */}
      </div>

      <ReportProfileModal
        isOpen={isReportModalOpen}
        onCancel={() => setIsReportModalOpen(false)}
        onConfirm={(selectedReason) => {
          reportProfileMutate(
            {
              reported_user_id: selectedThread.id,
              reason: selectedReason,
            },
            {
              onSuccess: () => {
                setIsReportModalOpen(false);
              },
            }
          );
        }}
      />
    </div>
  );
};

export default ChatHeader;
